import { apiCall } from '../../context/api';

export const fetchRunBatch = async (token, base_url, body) => {
  if (!token) return null;

  await apiCall(base_url, token, 'POST', '/core/webhooks/batches/run-batch', body);
};
